import React from 'react';
import { List } from 'semantic-ui-react';

export const profile = {
  name: '潘中昊',
  email: 'ericpzhpuma@gmail.com',
  github: 'https://github.com/ericpzh',
};

export const experiences = [
  {
    type: 'simple',
    header: '软件工程师, Snowflake',
    headerLink: 'https://www.snowflake.com/',
    date: '2026–至今',
    items: [
      <>作为 Snowflake Datalake 团队成员，为<a href="https://docs.snowflake.cn/zh/user-guide/tables-iceberg-configure-catalog-integration" className="agent-window__link">目录集成（Catalog Integration）</a>领域贡献了多项功能。</>,
      <>改进了目录平台的错误处理与指标体系；构建了多个仪表板，呈现客户对<a href="https://docs.snowflake.cn/zh/user-guide/tables-iceberg-configure-catalog-integration" className="agent-window__link">目录集成</a>功能的使用情况。</>,
      <>优化了 Snowflake 的 <a href="https://docs.snowflake.cn/zh/user-guide/tables-iceberg-configure-catalog-integration-rest-glue" className="agent-window__link">Glue Catalog 集成</a>与 <a href="https://aws.amazon.com/blogs/aws/amazon-s3-tables-integration-with-amazon-sagemaker-lakehouse-is-now-generally-available/" className="agent-window__link">S3 Tables Bucket</a> Iceberg REST Catalog 集成框架，支持客户直接对接 <a href="https://docs.aws.amazon.com/AmazonS3/latest/userguide/s3-tables-integrating-open-source.html" className="agent-window__link">S3 Tables Bucket 的 Iceberg REST Catalog 端点</a>。</>,
      <>推出了 <a href="https://docs.snowflake.cn/zh/user-guide/tables-iceberg-configure-catalog-integration-rest-onelake" className="agent-window__link">Snowflake Iceberg REST Catalog 集成</a>，与 <a href="https://learn.microsoft.com/zh-cn/fabric/onelake/table-apis/iceberg-table-apis-overview" className="agent-window__link">Microsoft OneLake</a> 对接，使用凭据分发和工作区级别 PrivateLink。</>
    ]
  },
  {
    type: 'expandable',
    header: '软件工程师, Amazon Web Services | Redshift',
    headerLink: 'https://aws.amazon.com/cn/redshift/',
    date: '2022–2026',
    items: [
      {
        title: '在 Redshift 查询处理团队中，为 Parser-Analyzer、Governance 和 Data Sharing 领域贡献了多项功能。',
        details: <div>
          <div className="contribution-tier1"><b><a href="#parser">解析器/分析器</a> 领域贡献</b></div>
          <div className="contribution-tier1"><b><a href="#governance">治理</a> 领域贡献：</b></div>
          <div className="contribution-tier2"><a href="#rlsor">OR 组合行级安全</a></div>
          <div className="contribution-tier1"><b>数据共享领域贡献：</b></div>
          <div className="contribution-tier2"><a href="#lagoon">Glue 数据目录视图</a></div>
          <div className="contribution-tier2"><a href="#s3tables">S3 表桶</a></div>
          <div className="contribution-tier2">当远程表存在仅大小写不同的列名（如 "COL" 与 "col"）时，阻止对 AWS Lake Formation 管理的 Redshift 数据共享表的查询，以消除冲突。</div>
          <div className="contribution-tier2">修复了一个长期存在的 bug：跨数据库或数据共享查询中的外部列名始终被转为小写，无视 <a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/r_enable_case_sensitive_identifier.html">enable_case_sensitive_identifier</a> 配置。</div>
        </div>
      },
      {
        id: 's3tables',
        title: <>设计并实现了 Redshift 与 <a href="https://aws.amazon.com/cn/blogs/aws/amazon-s3-tables-integration-with-amazon-sagemaker-lakehouse-is-now-generally-available/">S3 表存储桶</a> 的集成。2025 年圆周率日正式上线；截至 2025 年底日均 <b>30,000+</b> 次查询。</>,
        details: <>
          <List.Item> 协调了 <a href="https://docs.aws.amazon.com/zh_cn/AmazonS3/latest/userguide/s3-tables-integrating-redshift.html"> S3 表存储桶 </a>、AWS Lake Formation 和 Amazon Redshift 之间的查询集成。 </List.Item>
          <List.Item> 扩展了 RedLake（Redshift 通过 Lake Formation 目录实现的跨集群数据共享）自动挂载器，使其能够从 Lake Formation 目录挂载 S3 表，确保 Redshift 原生数据库与 Lake Formation 目录同步创建和删除。 </List.Item>
          <List.Item> 实现了查询处理层面的变更，以处理 Lake Formation 的嵌套目录结构并将其转换为 Iceberg 表。 </List.Item>
          <List.Item> 设计并执行了系统性功能测试矩阵，覆盖所有查询路径——数据库连接、外部 schema、数据库等——针对多种用户类型，包括 FAS、IAM 角色和 IDC 用户连接。 </List.Item>
          </>
      },
      {
        id: 'lagoon',
        title: <>主导了 Redshift 与 <a href="https://aws.amazon.com/cn/about-aws/whats-new/2023/11/aws-glue-data-catalog-multi-engine-views-analytics-engines/">Glue 数据目录视图</a> 的集成。2023 年 re:Invent 预览；2024 年正式上线。截至 2025 年底：日均 <b>600,000+</b> 次查询，覆盖 <b>1,000+</b> 个集群。</>,
        details: <>
          <List.Item> 开发了 <a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/data-catalog-views-overview.html"> Glue 数据目录视图 </a> 多方言视图（支持 AWS Redshift、AWS Athena 和 AWS EMR Spark），由 AWS Lake Formation 目录管理，具有通过 RLS 保护扫描边界的受保护访问和基于定义者的权限，仅创建者可访问视图定义，权限基于其对底层关系的权限。 </List.Item>
          <List.Item> 实现了映射到 Glue API（CreateTable、UpdateTable、DeleteTable）的 CREATE、ALTER 和 DROP SQL 支持，以及映射到 Glue GetTables API 的 SHOW VIEW SQL 支持。 </List.Item>
          <List.Item> 实现了基于会话的认证令牌来获取作为视图定义者的 Lake Formation 权限的查询执行，具有严格的 schema 验证（定义者权限变更时报错）和 RLS 边界强制（无 explain 计划，限制谓词下推到单个表扫描）。 </List.Item>
          <List.Item> 设计并执行了系统性功能测试矩阵，覆盖所有查询方式——数据库连接、外部 schema、数据库等——针对多种用户类型，包括 FAS、IAM 角色和 IDC 用户连接。 </List.Item>
          </>
      },
      {
        id: 'rlsor',
        title: <>主导了 <a href="https://aws.amazon.com/cn/about-aws/whats-new/2023/11/amazon-redshift-row-level-security-enhancements/">OR 组合行级安全</a> 功能的开发，支持以 OR 逻辑组合多个 RLS 策略。该功能被约 <b>10%</b> 的 RLS 保护关系所使用。</>,
        details: <>
          <List.Item> <a href='https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/t_rls_combine_policies.html'> RLS 组合 </a>模式在关系级别定义，可选的 OR 组合模式使用逻辑 OR 合并多个策略，等同于 PostgreSQL 的 PERMISSIVE 关键字。 </List.Item>
          <List.Item> 开发了 SQL DDL 语法表面，使用户能够修改单个关系（包括表、视图、物化视图和延迟绑定视图）的组合模式。 </List.Item>
          </>
      },
      {
        id: 'parser',
        title: <>为多个解析器-分析器增强功能做出了贡献，包括<a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/r_enable_case_sensitive_super_attribute.html">区分大小写的标识符解析</a>、改进的语法错误信息、展平长限定条件列表以防止栈溢出，以及系统表查询的谓词下推——将某客户工作负载的中位响应时间降低了 <b>98%</b>（从 228ms 降至 3ms）。</>,
        details: <>
          <List.Item> 设计并交付了新的配置选项 <a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/r_enable_case_sensitive_super_attribute.html"> enable_case_sensitive_super_attribute </a>，允许用户以区分大小写的方式引用 SUPER 属性，无需添加引号。 </List.Item>
          <List.Item> 设计并交付了更详细的语法错误信息，在出错位置显示行号及周围上下文。 </List.Item>
          <List.Item> 修改了将标量 INT 数组转换为标量 VARCHAR 数组以用于 LHS 列为 VARCHAR 的 JOIN 时的行为。此前会在查询计划中生成 OR 列表；现已对齐 INT LHS 与 VARCHAR RHS 数组的处理方式，避免了因递归过深导致的栈溢出（SIGSEGV）。</List.Item>
          <List.Item> 增加了保护机制，防止在事务提交期间删除表的最后一列。将列的实际删除操作和列计数目录更新延迟至提交结束时统一处理，实现了批量删除以避免 O(N²) 列循环，并确保目录索引正确更新。</List.Item>
          <List.Item> 新增了布尔配置被设为空字符串时的报错：此前 SET config TO '' 会静默设为 True，现改为抛出错误。 </List.Item>
          <List.Item> 在解析器分析器早期阶段展平了长 AND/OR 和大 IN 列表，以避免因深层左嵌套树导致的计划器栈溢出。 </List.Item>
          <List.Item> 改进了 Redshift 查询重写器对大尺寸谓词列表的处理。此前，展平后的大型 AND/OR 列表会导致多次 O(N²) 遍历，现在当谓词列表过大时将跳过重写器。 </List.Item>
          <List.Item> 修复了在查询处理过程中，当包含特殊字符的表列被输出到 Redshift 生成的 C++ 代码时可能存在的 SQL 代码注入漏洞。 </List.Item>
          <List.Item> 修复了日期/时间转换过程中因整数溢出导致的不正确的日期时间转换结果。 </List.Item>
          </>
      },
      {
        title: <>使用机器学习推荐 Spark SQL 配置的概念验证，在基准测试工作负载上相比 Spark EMR 默认配置实现了 15–50% 的性能提升。该模型使用基于 CNN 的回归器，以 Spark SQL 的逻辑计划、表统计信息和配置参数作为输入来预测查询运行时间。后续优化模块应用梯度下降来推荐改进的配置设置。</>,
        details: <>
          <List.Item> 构建了两阶段模型结构，实现了零调优时间预测。 </List.Item>
          <List.Item> 在第一阶段，训练了一个 CNN 模型，使用 Spark 优化后的逻辑查询计划、Spark 配置和表统计信息，通过 Spark Telemetry 查询计划脱敏器基于集群遥测数据预测查询执行时间。 </List.Item>
          <List.Item> 在第二阶段，使用梯度下降优化器推荐最佳的 Spark 配置（如分区数、JOIN 阈值），范围受每个配置参数的集群级最小值和最大值的安全边界限制。 </List.Item>
          <List.Item> 在 TPC-DS 基准测试以及来自 Netflix 和 Sanofi 等客户的实际工作负载上验证了该方法，数据由解决方案架构师提供。 </List.Item>
          </>
      },
      {
        id: 'governance',
        title: <>参与了多个治理项目，包括<a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/t_ddm.html">动态数据脱敏</a>（DDM）、数据共享细粒度访问控制（FGAC）、安全日志记录和服务日志脱敏器，解决了关键运营挑战。</>,
        details: <>
          <List.Item> 为 DDM 的 <a href="https://docs.aws.amazon.com/zh_cn/redshift/latest/dg/t_ddm-super.html"> 属性级保护 </a>（ALP）提供了代码审查，该功能允许客户对单个 SUPER 属性应用 DDM 策略。 </List.Item>
          <List.Item> 协助设计和实现了安全日志记录——一个基于 DDM 的功能，在查询时应用于定义者视图，从消费者视角屏蔽所有与这些视图相关的系统表条目。 </List.Item>
          <List.Item> 修复了当两个同类型标识符仅大小写不同（如 col 和 COL）被包含在策略中时，RLS/DDM 策略行为因会话级配置而改变的问题。 </List.Item>
          <List.Item> 设计了数据共享细粒度访问控制（DS FGAC），在 Redshift 的跨集群数据共享环境中提供 FGAC 策略 DDL 和应用。设计了跨集群列级保护（CLP）、行级安全（RLS）和动态数据脱敏（DDM）策略创建和附加的 SQL 接口。实现了一个单元测试框架，通过将出站服务器调用重定向到本地客户端来模拟数据共享读取。 </List.Item>
          <List.Item> 为服务日志脱敏器提供了代码审查——利用 DDM 和安全日志记录的概念，在日志创建期间使用原生解析器在 Redshift 的内部日志和监控系统表中原地脱敏客户数据，实现客户集群内的安全调试。 </List.Item>
          </>
      }
    ]
  },
  {
    type: 'simple',
    header: '软件工程师, Petuum Inc.',
    headerLink: 'https://opro.ai/',
    date: '2021–2022',
    items: [
      '为 Phillips 66 构建了高级过程控制应用，使用 LSTM 和遗传算法进行实时多目标优化。',
      '开发了推断模型，从低频实验室数据估计高频传感器值。',
      '通过批处理/向量化改进推断延迟；通过并行化加速训练流水线。'
    ]
  },
  {
    type: 'simple',
    header: '参考数据实习生, Citadel',
    headerLink: 'https://www.citadel.com/',
    date: '2020',
    items: [
      '使用正则表达式、SVM、MLP 和 Word2Vec 为可转换债券条款清单创建了 PDF 解析器。准确率达 70–90%。',
      '构建了全栈自助服务门户（React/Django），包含数据仪表板、PDF 解析器和 Jira 集成。'
    ]
  },
  {
    type: 'simple',
    header: '研究助理, UIUC | John Deere',
    headerLink: 'http://esol.ise.illinois.edu',
    date: '2018–2020',
    items: [
      '使用 GWP100a 和 ReCiPe 指标为建筑和农业机械构建了基于 Excel 的 LCA 和 LCC 工具。',
      '支持设计方案之间的敏感性分析和比较。',
      '开发了可视化 LCA/成本的 Web 应用用于材料选择（可持续材料顾问）。',
      '参与了可持续材料和自主性研究。'
    ]
  },
  {
    type: 'simple',
    header: 'SE 101 助教, UIUC',
    headerLink: 'https://productdesignlab.ise.illinois.edu/',
    date: '2019–2021',
    items: [
      '向新生教授工程制图和 CAD。',
      '带领 30+ 学生的实验课；管理作业和项目。'
    ]
  }
];

export const education = {
  degrees: [
    {
      url: 'https://ise.illinois.edu/',
      school: '伊利诺伊大学厄巴纳-香槟分校，2016-2021',
      details: [
        '工业工程硕士，高级分析方向，GPA：3.96/4.0',
        '工业工程学士，计算机科学辅修，GPA：3.88/4.0'
      ]
    }
  ],
  research: [
    {
      url: 'https://predictrend-6a51c.web.app/',
      label: '时间序列趋势预测',
      text: '使用 ARIMA、LSTM、GRU 和 CEEMDAN 预测了 2020 年美国大选概率及标普500指数。'
    },
    {
      url: 'https://www.tandfonline.com/doi/full/10.1080/19397038.2021.1919785',
      label: '自主割草机 LCA 研究',
      text: '合著案例研究与建模论文。'
    },
    {
      url: 'https://asmedigitalcollection.asme.org/IDETC-CIE/proceedings-abstract/IDETC-CIE2020/83952/V006T06A030/1089947',
      label: '可持续材料可视化工具',
      text: '合著数据分析与 Web 开发论文。'
    }
  ],
  coursework: [
    [
      { url: 'https://courses.illinois.edu/schedule/2019/fall/IE/529', label: '大数据统计与聚类' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/IE/531', label: '数据分析算法' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/498', label: '数据科学与分析' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/446', label: '机器学习' }
    ],
    [
      { url: 'https://courses.illinois.edu/schedule/2020/fall/IE/532', label: '网络数据分析' },
      { url: 'https://courses.illinois.edu/schedule/2021/spring/CS/547', label: '深度学习' },
      { url: 'https://courses.illinois.edu/schedule/2018/fall/CS/411', label: '数据库系统' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/412', label: '数据挖掘' }
    ]
  ],
  aiTools: ['Claude Code', 'Cursor', 'Cortex Code'],
  skills: ['Python', 'Java', 'Snowflake SQL', 'C++', 'HTML/CSS', 'JavaScript', 'Scala', 'PostgreSQL', 'Pandas', 'React', 'VBA', 'MongoDB']
};

export const projects = [
  {
    name: 'Metro 地铁站设计器',
    bgImage: 'metro.svg',
    url: 'https://ericpzh.rest/metro/',
    hasSubItems: true,
    items: [
      '使用 React、Three.js 和 Web Worker 仿真构建了 3D 地铁站沙盒。通过方块搭建多层车站、连接站台，并观察乘客流动以优化车站布局。'
    ],
    subItems: [
      { name: '开始游戏', url: 'https://ericpzh.rest/metro/', icon: 'gamepad' },
      { name: 'Metro GitHub 源码', url: 'https://github.com/ericpzh/metro/tree/main' }
    ]
  },
  {
    name: 'Airport Control 27 模组',
    bgImage: 'ac27.jpg',
    hasSubItems: true,
    items: [
      '使用 C#、Unity、Electron 和 JavaScript 为 Airport Control 27 开发了模组和工具：'
    ],
    subItems: [
      { name: 'AC27Skin', url: 'https://github.com/ericpzh/AC27Skin' },
      { name: 'AC27Editor', url: 'https://github.com/ericpzh/AC27LevelEditor' }
    ]
  },
  {
    name: 'Mini Airways 游戏模组',
    url: 'https://store.steampowered.com/app/2289650/Mini_Airways__ATC_simulator/',
    bgImage: 'mini_airways.jpg',
    hasSubItems: true,
    items: [
      '使用 C# 和 Unity 为 Mini Airways 开发了多个游戏模组，包括：'
    ],
    subItems: [
      { name: 'MiniRealisticAirways', url: 'https://github.com/ericpzh/MiniRealisticAirways' },
      { name: 'AirwaysCEO', url: 'https://github.com/ericpzh/AirwaysCEO' },
      { name: 'MiniCenterControl', url: 'https://github.com/ericpzh/MiniCenterControl' },
      { name: 'MiniFighters', url: 'https://github.com/ericpzh/MiniFighters' },
      { name: 'MiniAirwaysILS', url: 'https://github.com/ericpzh/MiniAirwaysILS' },
      { name: 'MiniTower', url: 'https://github.com/ericpzh/MiniTower' }
    ]
  },
  {
    name: '气缸加工线仿真 – Caterpillar',
    bgImage: 'caterpillar.jpg',
    url: 'https://ise.illinois.edu/undergraduate/senior-engineering-program.html',
    items: [
      '使用 ProModel 构建了发动机气缸加工线的仿真模型，包含维护、换班和零件流动逻辑。',
      '推荐了调度/设备变更方案，以更低成本满足需求。'
    ]
  },
  {
    name: 'Vtubers Feed 应用',
    url: 'https://vtubersfeed.web.app/',
    items: [
      '基于 React Native、Redux、Express 和 MongoDB 的跨平台新闻聚合应用。'
    ]
  },
  {
    name: 'COVID-19 网络分析',
    url: null,
    items: [
      '使用网络分析指标识别了 COVID-19 传播中的关键美国县域。'
    ]
  },
  {
    name: 'WOWS 数据库',
    url: 'https://longislandwithouticetea.github.io/cs498rk_fp/#/',
    items: [
      '使用 React、Express、MySQL 和 Plotly.JS 的游戏统计网站。'
    ]
  },
  {
    name: '客机登机仿真',
    url: 'https://www.youtube.com/watch?v=NQWfc4mLqfo',
    items: [
      '使用 Python 事件仿真和动画比较不同的登机策略。'
    ]
  },
  {
    name: '金融工程工具箱',
    url: null,
    items: [
      '基于 Flask 的应用，提供期权定价、投资组合优化和实时数据模拟交易功能。'
    ]
  },
  {
    name: 'OR 求解器',
    url: null,
    items: [
      'Python 应用，求解线性规划、博弈论问题，以及棋盘游戏 "Breakthrough" 的 AI。'
    ]
  },
  {
    name: '鼠标手套',
    url: 'https://wiki.illinois.edu/wiki/display/ECE110HLSF15/Mouse+Glove',
    items: [
      'Arduino 手套，通过传感器数据和蓝牙向 Java 接收器模拟鼠标/摇杆功能。'
    ]
  }
];
